import apiHandler from "../core/apiHandler";

const inventoryStockApi = apiHandler('inventory/stock');
export default inventoryStockApi;
